import React, { Fragment } from 'react';
import { lerp } from '../../Services/utilities';
import { translate } from '../../Services/translation';

const PanelCuttingImage = ({ id, rules, angleA, angleB, focusA, focusB }) => {
  const className = 'cut-image';
  const margin = 10;
  const box = {
    x: 10,
    y: 200,
    width: 1180,
  };
  const viewBox = {
    x: 0,
    y: 0,
    width: 1200,
    height: 400,
  };

  const calculateCorner = (corner, angle, box) => {
    if (corner > 0) {
      let result = calculateAngle(angle);

      if (corner === 1) {
        box.c4.x += result;
      } else if (corner === 4) {
        box.c1.x += result;
      } else if (corner === 3) {
        box.c2.x -= result;
      } else if (corner === 2) {
        box.c3.x -= result;
      }
    }
  };

  const calculateAngle = (angle) => {
    let angleRad = toRadian(angle),
      angle2Rad = toRadian(90 - angle),
      hyp = rules.boxHeight / Math.sin(angle2Rad);

    return hyp * Math.sin(angleRad);
  };

  const toRadian = (angle) => {
    return (angle / 180) * Math.PI;
  };

  const getCornerPosition = (corner) => {
    let basicBox = getBasicBox(box.x, box.y);
    return basicBox['c' + corner];
  };

  const getBasicBox = (x, y) => {
    return {
      c1: { x: x, y: y },
      c2: { x: x + box.width, y: y },
      c3: { x: x + box.width, y: y + rules.boxHeight },
      c4: { x: x, y: y + rules.boxHeight },
    };
  };

  const getCalcBox = (x, y) => {
    let basicBox = getBasicBox(x, y),
      calcBox = getBasicBox(x, y);

    calculateCorner(rules.cornerA, angleA, calcBox);
    calculateCorner(rules.cornerB, angleB, calcBox);

    return calcBox;
  };

  const getBoxPath = (calcBox) => {
    return `M${calcBox.c1.x} ${calcBox.c1.y} ${calcBox.c2.x} ${calcBox.c2.y} ${calcBox.c3.x} ${calcBox.c3.y} ${calcBox.c4.x} ${calcBox.c4.y}Z`;
  };

  const getFocusClass = () => {
    if (focusA) {
      return ' angle-focus angle-focus--a';
    } else if (focusB) {
      return ' angle-focus angle-focus--b';
    }

    return '';
  };

  const getTextPosition = (corner, angle) => {
    let basicBox = getBasicBox(box.x, box.y),
      calcBox = getBasicBox(box.x, box.y);

    calculateCorner(corner, angle, calcBox);

    if (corner === 4) {
      let m = lerp(0.5, basicBox.c1.x, calcBox.c1.x);

      return {
        x: m > 40 ? m : 40,
        y: basicBox.c1.y - 14,
      };
    } else if (corner === 3) {
      let m = lerp(0.5, basicBox.c2.x, calcBox.c2.x);

      return {
        x: m < basicBox.c2.x - 30 ? m : basicBox.c2.x - 30,
        y: basicBox.c2.y - 14,
      };
    } else if (corner === 2) {
      let m = lerp(0.5, basicBox.c3.x, calcBox.c3.x);

      return {
        x: m < basicBox.c3.x - 30 ? m : basicBox.c3.x - 30,
        y: basicBox.c3.y + 56,
      };
    } else if (corner === 1) {
      let m = lerp(0.5, basicBox.c4.x, calcBox.c4.x);

      return {
        x: m > 40 ? m : 40,
        y: basicBox.c4.y + 56,
      };
    }

    return cornerPosition;
  };

  return (
    <svg className={className + getFocusClass()} viewBox={`${viewBox.x} ${viewBox.y} ${viewBox.width} ${viewBox.height}`}    >
      <defs>
        <clipPath id={'canvas-cutoff-' + id}>
          <rect
            x={viewBox.x}
            y={viewBox.y}
            width={viewBox.width}
            height={box.y + rules.boxHeight}
          />
        </clipPath>
        <clipPath id={'box-cutoff-' + id}>
          <rect
            x={box.x}
            y={box.y}
            width={box.width}
            height={rules.boxHeight}
          />
        </clipPath>
        <clipPath id={'calcbox-cutoff-' + id}>
          <path d={getBoxPath(getCalcBox(0, 0))} />
        </clipPath>
      </defs>

      {rules.background && (
        <use href='#cut-bg' style={{ color: '#dadce0' }} clipPath={'url(#canvas-cutoff-' + id + ')'} />
      )}

      {rules.cornerA > 0 && (
        <circle
          className='angle-circle angle-circle--a'
          cx={getCornerPosition(rules.cornerA).x}
          cy={getCornerPosition(rules.cornerA).y}
          r={rules.boxHeight * 0.6}
          fill='transparent'
          clipPath={'url(#box-cutoff-' + id + ')'}
          strokeWidth='5'
        />
      )}

      {rules.cornerB > 0 && (
        <circle
          className='angle-circle angle-circle--b'
          cx={getCornerPosition(rules.cornerB).x}
          cy={getCornerPosition(rules.cornerB).y}
          r={rules.boxHeight * 0.6}
          fill='transparent'
          clipPath={'url(#box-cutoff-' + id + ')'}
          strokeWidth='5'
        />
      )}

      <use
        x={box.x}
        y={box.y}
        href={'/ui/images/sprites/be-cut-pattern.svg#' + rules.background}
        className='beam-box-inner'
        clipPath={'url(#calcbox-cutoff-' + id + ')'}
      />
      <path
        d={getBoxPath(getCalcBox(box.x, box.y))}
        className='beam-box'
        fill='transparent'
        strokeWidth='5'
      />

      {rules.cornerA > 0 && (
        <text
          textAnchor='middle'
          className='svg-text svg-text--a'
          x={getTextPosition(rules.cornerA, angleA).x}
          y={getTextPosition(rules.cornerA, angleA).y}
        >
          a
        </text>
      )}

      {rules.cornerB > 0 && (
        <text
          textAnchor='middle'
          className='svg-text svg-text--b'
          x={getTextPosition(rules.cornerB, angleB).x}
          y={getTextPosition(rules.cornerB, angleB).y}
        >
          b
        </text>
      )}
    </svg>
  );
};

export default PanelCuttingImage;
